"use client";
import { Col, Row } from "@/utils/bootstrap";
import AllCartItems from "./all-cart-items/AllCartItems";
import CartButtons from "./cart-buttons/CartButtons";
import Promo from "./promo/Promo";
import {
  useGetCartQuery,
  useGetUserLocation,
} from "@/api/AppApi/services/cart";
import { useIsMobile } from "@/hooks/useIsMobile";
import AssociatedProducts, {
  AssociatedProductsTypes,
} from "../common/associated-products/AssociatedProducts";
import GeneralApiLoader from "../../lib/loaders/GeneralApiLoader";
import CartEmpty from "./CartEmpty";
import { TabbyPromo } from "../../lib/Tabby";
import useCanTabby from "@/hooks/useCanTabby";
import ViewCartPixel from "./ViewCartPixel";
import useSellingMode from "@/hooks/useSellingMode";
import { useEffect } from "react";
import { useRouter } from "../../lib/navigation/useRouter";

const Cart = () => {
  const getCart = useGetCartQuery();
  const { enableSells, isFetching } = useSellingMode();
  const router = useRouter();
  const cart = getCart?.data?.result;
  const { items, discount, tax, total, coupon, shipping_charge } = cart ?? {};
  const mobile = useIsMobile();
  const canTabby = useCanTabby();
  const getUserLocation = useGetUserLocation({});
  const userLocationCode = getUserLocation?.data?.country_code;

  useEffect(() => {
    if (isFetching) return;
    if (!enableSells) router.replace("/");
  }, [enableSells, isFetching]);
  if (getCart.isFetching || isFetching) return <GeneralApiLoader />;
  if (!cart || !items) return null;
  if (items?.length === 0) return <CartEmpty />;
  const mClass = mobile ? "-mobile" : "";
  const ids = items?.map((item) => item.id);
  return (
    <>
      <Row className="m-0 mb-4" style={{ gap: mobile ? 28 : 32 }}>
        <Col className="p-0" lg={6}>
          <AllCartItems cartItems={items} mobile={mobile} />
        </Col>
        <Col className="p-0" lg={{ span: true }}>
          <div className={`cart-promo${mClass} w-100`}>
            <CartButtons tax={cart?.tax} total={cart?.total} mobile={mobile} />
            <Promo
              promoCode={cart.coupon ? cart.coupon?.code : ""}
              promoDiscount={cart?.coupon ? cart.coupon?.discount : 0}
              mobile={mobile}
              countryCode={userLocationCode!}
            />
            {canTabby && <TabbyPromo price={cart?.total} source="cart" />}{" "}
          </div>
        </Col>
      </Row>

      <AssociatedProducts type={AssociatedProductsTypes.cross_sell} id={ids} />
      <ViewCartPixel
        cartItems={items}
        tax={tax!}
        value={total!}
        coupon={coupon?.code!}
        shipping={shipping_charge!}
        discount={discount!}
      />
    </>
  );
};

export default Cart;
